export const TITLE_OF_DOCUMENTS = {
  attorneyPowerCopy: 'Copia del poder notarial',
  authorizationLetter: 'Carta de autorización',
  complianceOpinion: 'Opinión de cumplimiento',
  incorporationArticlesCopy: 'Copia acta constitutiva',
  rfcCopy: 'Copia de RFC',
  taxId: 'Cédula fiscal',
  vehicleRequest: 'Solicitud de vehículos',
};
